import { makeStyles } from '@material-ui/core/styles';

const renderDaysStyle = makeStyles(() => ({
	dayBg: {
		backgroundColor: '#EBE8F3',
	},
	block: {
		width: 350 / 10,
		height: 280 / 10,
		color: '#333333',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#ffffff',
		fontSize: 12,
		fontWeight: 'bold',
		padding: 2,
		margin: 0.5,
		/* font-family: "bogle-regular"; */
	},
	range: {
		color: '#ffffff',
		backgroundColor: '#3c228a',
		borderRadius: 25,
	},
	disabled: {
		color: '#B2B0B9',
	},
	daySelected: {
		backgroundColor: '#EBE8F3',
	},
	nextDays: {
		color: '#7b7297',
	},
	prevDays: {
		color: '#7b7297',
	},
	dayTransparent: {
		backgroundColor: 'transparent',
	},
	today: {
		backgroundColor: '#0e4fbd',
		borderRadius: 50,
		color: '#ffffff',
	},
	dftCursor: {
		cursor: 'default',
	},
	pointerCursor: {
		cursor: 'pointer',
	},
}));

export default renderDaysStyle;
